var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{staticClass:"blue-grey--text title",attrs:{"shrink":""}},[_vm._v("Filtros")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }